/* ============================================================
   prem-eta-init.js — "¿Cuándo le llega?" en el form premium
   (product.liquid), para TODOS los productos.
   Aditivo: NO toca tiers, envío a Kommo, ni el submit.
   Reusa el motor ETA (lp-eta.js → window.ETA) + lp-zonas.json
   (window.LP_ZONAS_URL).

   Targetea los campos del form premium:
     - distrito : input[name="district"]
     - provincia: select[name="province"]
     - display  : [data-prem-eta]        (fecha por distrito/GPS, paso 2)
     - x envío  : [data-prem-eta-ship]    (plazo por método, paso 4)
   GPS: escucha el evento 'prem:geo' que dispara initGeo() en premium.js.
   ============================================================ */
(function () {
  'use strict';
  if (!window.ETA || !window.LP_ZONAS_URL) return;
  var ETA = window.ETA;
  var ZONAS = [];
  var form, distInput, provSel, box, shipBox, chip;
  var lastZona = null;
  var pendingGeo = null; // pin GPS recibido antes de que carguen los ZONAS → se reintenta al cargar
  var lastCoord = false; // true when the resolved zone needs WhatsApp coordination

  // Tarifa de envío (Kevin 2026-10-03): GAM ₡1.900 contra entrega, jamás gratis · Fuera del GAM ₡2.900
  // con el envío adelantado por SINPE · Encomienda ₡1.300 y Correos ₡2.300 con el total adelantado.
  var SHIP_GAM_CRC = 1900;
  var SHIP_FUERA_CRC = 2900;

  /* Costa Rica colón formatting (₡3.500) — matches the form's number style. */
  function fmtColon(n) {
    var v = Math.round(Number(n) || 0);
    return '₡' + v.toLocaleString('de-DE');
  }

  /* Reads the delivery date the ETA engine already rendered into
     [data-prem-eta] (.prem-eta__day) — never recomputes it (SHIP-02). */
  function etaDateText() {
    if (!box || box.hidden) return '';
    var dayEl = box.querySelector('.prem-eta__day');
    return dayEl ? (dayEl.textContent || '').trim() : '';
  }

  /* Surfaces the EXISTING shipping outcome into [data-ship-chip] via
     textContent (NOT innerHTML — courier/zone strings are an XSS vector,
     Security Domain T-01-20). Free-vs-paid is read from the selected
     input[name="shipping"] data-price/data-label; coord comes from the
     engine's noRoute signal (lastCoord). Empty prompt stays until a location
     resolves. No call into lp-eta.js, no recompute of shipping math. */
  function paintShipChip() {
    if (!chip || !form) return;
    // No location resolved yet → keep the server-rendered empty prompt.
    if (!lastZona && !lastCoord) return;
    if (lastCoord) {
      chip.textContent = 'Coordinamos su envío por WhatsApp';
      chip.setAttribute('data-ship-state', 'coord');
      return;
    }
    var sel = form.querySelector('input[name="shipping"]:checked');
    var price = sel ? (parseInt(sel.getAttribute('data-price'), 10) || 0) : 0;
    if (price === 0) {
      chip.textContent = 'Envío a todo el país 🚚';
      chip.setAttribute('data-ship-state', 'free');
    } else {
      var label = (sel && sel.getAttribute('data-label')) || (sel && sel.value) || 'mensajero';
      var date = etaDateText();
      var txt = 'Por ' + label + ' · ' + fmtColon(price);
      if (date) txt += ' · llega ' + date;
      chip.textContent = txt;
      chip.setAttribute('data-ship-state', 'paid');
    }
  }

  var cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s; };

  /* Plazo legible por método de envío (texto, no fecha de ruta) */
  var SHIP_PLAZO = {
    gam:           '1-2 días hábiles dentro del GAM',
    fuera_gam:     '1-3 días · fuera del GAM',
    encomienda:    'según la ruta de la encomienda',
    correos:       '1-2 días hábiles · todo el país'
  };

  function findDistrito(typed, provincia) {
    var v = ETA.norm(typed);
    if (v.length < 2) return null;
    var pv = ETA.norm(provincia || '');
    var pool = ZONAS.filter(function (z) { return ETA.norm(z.n) === v; });
    if (!pool.length) pool = ZONAS.filter(function (z) { return ETA.norm(z.n).indexOf(v) === 0; });
    if (!pool.length) pool = ZONAS.filter(function (z) { return ETA.norm(z.n).indexOf(v) >= 0; });
    if (!pool.length) return null;
    if (pv) {
      var byProv = pool.filter(function (z) { return ETA.norm(z.p) === pv; });
      if (byProv.length) return byProv[0];
    }
    return pool[0]; // el día por distrito es correcto aunque la provincia esté mal etiquetada
  }

  /* Envío por zona (Kevin 2026-10-03) — 4 opciones fijas y visibles: gam ₡1.900 · fuera_gam ₡2.900 ·
     encomienda ₡1.300 · correos ₡2.300. Ya NO colapsa el menú. Con la zona resuelta solo
     mueve la selección entre GAM y Fuera del GAM (si el cliente eligió Encomienda o Correos
     se respeta) y oculta la tarifa de mensajería que no le corresponde.
       state: 'GAM' | 'FUERA' (zona firme) · 'PENDING' (sin ubicación / por confirmar). */
  function setZoneShipping(state) {
    if (!form) return;
    var gam = form.querySelector('input[name="shipping"][value="gam"]');
    var fuera = form.querySelector('input[name="shipping"][value="fuera_gam"]');
    if (!gam || !fuera) return;
    var gCard = gam.closest('.prem-radio-card') || gam.closest('label');
    var fCard = fuera.closest('.prem-radio-card') || fuera.closest('label');
    gam.setAttribute('data-price', String(SHIP_GAM_CRC));
    fuera.setAttribute('data-price', String(SHIP_FUERA_CRC));
    var showG = state !== 'FUERA', showF = state !== 'GAM';
    if (gCard) gCard.hidden = !showG; gam.disabled = !showG;
    if (fCard) fCard.hidden = !showF; fuera.disabled = !showF;
    var sel = form.querySelector('input[name="shipping"]:checked');
    var target = null;
    if (state === 'GAM' && (!sel || sel === fuera)) target = gam;
    else if (state === 'FUERA' && (!sel || sel === gam)) target = fuera;
    else if (!sel) target = gam;
    if (target) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* Kevin (2026-06-29): que SIEMPRE se vea el TOTAL con envío "abajo".
     La barra fija .prem-sticky-cta solo aparece al hacer scroll (no basta). El botón
     visible permanente es #prem-submit-btn ("Hacer pedido"): le inyectamos una línea
     "Total con envío: ₡X" sincronizada con [data-total] (que premium.js recalcula en cada
     cambio: cantidad/garantía/envío). También alimentamos la barra fija si existe. */
  function mirrorTotalToSticky() {
    var totalEl = document.querySelector('[data-total]');
    if (!totalEl) return;
    var stickyNow = document.querySelector('.prem-sticky-cta__now');
    var wasEl = document.querySelector('.prem-sticky-cta__was');
    var cta = document.getElementById('prem-submit-btn');
    var ctaTotal = null;
    if (cta) {
      ctaTotal = cta.querySelector('[data-cta-total]');
      if (!ctaTotal) {
        ctaTotal = document.createElement('span');
        ctaTotal.setAttribute('data-cta-total', '');
        ctaTotal.style.cssText = 'display:block;font-size:.8em;font-weight:700;opacity:.95;margin-top:3px;line-height:1.15';
        cta.appendChild(ctaTotal);
      }
    }
    var sync = function () {
      // FIX 27-sep (Kevin, error gravísimo): la barra fija / sticky-cta SIEMPRE debe
      // mostrar el PRECIO DEL PRODUCTO (el mismo que la imagen del anuncio), nunca el
      // total con envío. Antes esta función copiaba [data-total] (que podía incluir un
      // envío placeholder de ₡3.900) directo al ".prem-sticky-cta__now", mostrando
      // ₡60.800 en vez de ₡56.900. Ya NO se toca stickyNow aquí.
      var shipLine = document.querySelector('[data-line="shipping"]');
      var hasShip = !!(shipLine && !shipLine.hidden);
      if (ctaTotal) {
        if (hasShip) {
          var t = (totalEl.textContent || '').trim();
          if (t) { ctaTotal.hidden = false; ctaTotal.textContent = 'Total con envío: ' + t; }
        } else {
          ctaTotal.hidden = true;
          ctaTotal.textContent = '';
        }
      }
    };
    sync();
    try { new MutationObserver(sync).observe(totalEl, { childList: true, characterData: true, subtree: true }); } catch (e) {}
  }

  function render(z) {
    lastZona = z || null;
    if (!box) { lastCoord = false; setZoneShipping(z ? (z.prio ? 'GAM' : 'FUERA') : 'PENDING'); paintShipChip(); return; }
    if (!z) { box.hidden = true; box.innerHTML = ''; lastCoord = false; setZoneShipping('PENDING'); return; }
    var props = { name: z.n, prov: z.p, days: z.d || [], prioritario: !!z.prio };
    var r = ETA.calcETA(props, new Date(), 'standard');
    box.hidden = false;
    if (r.noRoute) {
      box.className = 'prem-eta prem-eta--coord';
      box.innerHTML = '<div class="prem-eta__lead">Su zona requiere coordinación</div>' +
        '<div class="prem-eta__sub">Un asesor le confirma la fecha de entrega por WhatsApp.</div>';
      lastCoord = true;
      setZoneShipping('PENDING'); // zona lejana → estimado seguro + chip "Coordinamos por WhatsApp"
      paintShipChip();
      return;
    }
    lastCoord = false;
    box.className = 'prem-eta';
    var html = '<div class="prem-eta__lead">Su pedido llegaría aprox.</div>' +
      '<div class="prem-eta__day">' + cap(r.formatted) + '</div>';
    html += '<div class="prem-eta__sub">Zona: <b>' + cap((props.name || '').toLowerCase()) + '</b>. Entregamos el próximo día de ruta disponible.</div>';
    box.innerHTML = html;
    setZoneShipping(props.prioritario ? 'GAM' : 'FUERA'); // prio:true = GAM ₡1.900 · si no, Fuera del GAM ₡2.900
    paintShipChip();
  }

  function updateFromText() {
    if (!distInput) return;
    render(findDistrito(distInput.value, provSel ? provSel.value : ''));
  }

  function renderShip() {
    if (!shipBox || !form) return;
    var sel = form.querySelector('input[name="shipping"]:checked');
    if (!sel) { shipBox.hidden = true; return; }
    var plazo = SHIP_PLAZO[sel.value];
    var label = sel.getAttribute('data-label') || sel.value;
    if (!plazo) { shipBox.hidden = true; return; }
    shipBox.hidden = false;
    shipBox.innerHTML = '<span class="prem-eta-ship__ico">🚚</span> Con <b>' + label + '</b>: le llegaría en <b>' + plazo + '</b>.';
  }

  function nearestZona(lat, lng) {
    var best = null, bd = 1e9;
    for (var i = 0; i < ZONAS.length; i++) {
      var z = ZONAS[i];
      if (!z.c) continue;
      // z.c = [lng, lat]; ETA.hav espera (lat1, lng1, lat2, lng2) → pasar lat=z.c[1], lng=z.c[0].
      var d = ETA.hav(lat, lng, z.c[1], z.c[0]);
      if (d < bd) { bd = d; best = z; }
    }
    return best;
  }

  function onGeo(e) {
    var d = e && e.detail;
    if (!d || d.lat == null || d.lng == null) return;
    // ZONAS aún no cargó (el cliente tocó GPS antes del fetch): guardar y reintentar al cargar.
    if (!ZONAS || !ZONAS.length) { pendingGeo = { lat: d.lat, lng: d.lng }; return; }
    // Inputs pueden no estar bound todavía si init() no corrió → resolverlos aquí.
    var root = document.getElementById('prem-purchase-form') || document;
    if (!distInput) distInput = root.querySelector('input[name="district"]');
    if (!provSel) provSel = root.querySelector('select[name="province"]');
    var cantonInput = root.querySelector('input[name="canton"]');
    var z = nearestZona(parseFloat(d.lat), parseFloat(d.lng));
    if (!z) return;
    // Provincia (z.pr) + cantón (z.ct) + distrito (z.n) AUTORITATIVOS (point-in-polygon
    // de cantones CR, no la antigua p). Solo si el campo está vacío (respeta edición).
    if (provSel && !provSel.value && z.pr) {
      provSel.value = z.pr; // las <option> usan el texto como value ('San José', etc.)
      if (provSel.value === z.pr) provSel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (cantonInput && !cantonInput.value && z.ct) {
      cantonInput.value = z.ct;
      cantonInput.dispatchEvent(new Event('input', { bubbles: true }));
      cantonInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (distInput && !distInput.value) {
      distInput.value = z.n;
      distInput.dispatchEvent(new Event('input', { bubbles: true }));
      distInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    render(z);
  }

  function buildDatalist() {
    if (document.getElementById('prem-distritos')) {
      if (distInput) distInput.setAttribute('list', 'prem-distritos');
      return;
    }
    var dl = document.createElement('datalist');
    dl.id = 'prem-distritos';
    var seen = {};
    ZONAS.forEach(function (z) {
      if (seen[z.n]) return; seen[z.n] = 1;
      var o = document.createElement('option');
      o.value = z.n;
      dl.appendChild(o);
    });
    document.body.appendChild(dl);
    if (distInput) distInput.setAttribute('list', 'prem-distritos');
  }

  function init() {
    form = document.getElementById('prem-purchase-form');
    if (!form) return;
    distInput = form.querySelector('input[name="district"]');
    provSel = form.querySelector('select[name="province"]');
    box = form.querySelector('[data-prem-eta]');
    shipBox = form.querySelector('[data-prem-eta-ship]');
    chip = form.querySelector('[data-ship-chip]');
    if (!distInput && !shipBox) return;

    if (distInput) {
      buildDatalist();
      distInput.addEventListener('input', updateFromText);
      distInput.addEventListener('change', updateFromText);
    }
    if (provSel) provSel.addEventListener('change', updateFromText);

    // (El listener 'prem:geo' se registra abajo, SIEMPRE — aunque ZONAS aún no cargue.)

    // Cambio de envío → línea de plazo por método + repintar chip (free/paid)
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'shipping') {
        renderShip();
        paintShipChip();
      }
    });
    renderShip();
    setZoneShipping('PENDING'); // muestra las 4 opciones; GAM ₡1.900 por defecto, nunca gratis
    mirrorTotalToSticky();      // la barra fija de abajo muestra el TOTAL (con envío), no solo el precio
  }

  // Listener 'prem:geo' SIEMPRE activo desde el arranque del script — así un tap de GPS
  // hecho antes de que carguen los 472 distritos NO se pierde (onGeo guarda pendingGeo).
  document.addEventListener('prem:geo', onGeo);

  fetch(window.LP_ZONAS_URL)
    .then(function (r) { return r.json(); })
    .then(function (z) {
      ZONAS = z;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
      else init();
      // Reintentar el pin que llegó antes de cargar ZONAS (race fix).
      if (pendingGeo) { var g = pendingGeo; pendingGeo = null; onGeo({ detail: g }); }
    })
    .catch(function () {});
})();
